'use strict';

module.exports = typeof Promise === 'function' ? Promise : require('pinkie');



//////////////////
// WEBPACK FOOTER
// ./~/pinkie-promise/index.js
// module id = 387
// module chunks = 0